<template>
  <div class="activate-info">
    <div class="activate-info-left">
      <div>
        <img class="logo-img"
             src="../../../../../public/img/iMatrix.png"
             alt=""
             @error="setDefaultImg"
             width="90%"
             height="100" />
      </div>
    </div>
    <div class='activate-info-right'>

      <div class="title"> 激 活 信 息 说 明 </div>
      <div>
        <div class="info-item">
          <div class="label">租&nbsp;&nbsp;户&nbsp;&nbsp;名&nbsp;&nbsp;称 : </div>
          <span class="content"
                :title="fromData.tenantName">{{ fromData.tenantName }}</span>
        </div>
        <div class="info-item">
          <div class="label">单&nbsp;&nbsp;位&nbsp;&nbsp;名&nbsp;&nbsp;称 : </div>
          <span class="content"
                :title="fromData.deptName">{{ fromData.deptName }}</span>
        </div>
        <div class="info-item">
          <div class="label">项&nbsp;&nbsp;目&nbsp;&nbsp;名&nbsp;&nbsp;称 : </div>
          <span class="content"
                :title="fromData.projectName">{{ fromData.projectName }}</span>
        </div>
        <div class="info-item">
          <div class="label">激&nbsp;&nbsp;活&nbsp;&nbsp;方&nbsp;&nbsp;式 : </div>
          <span class="content"
                :title="fromData.permanentActivationName">{{ fromData.permanentActivationName }}</span>
        </div>
        <div v-if="fromData.permanentActivation==0"
             class="info-item">
          <div class="label">系统到期时间 : </div>
          <span class="content"
                :title="fromData.loginExpiryTime">{{ fromData.loginExpiryTime }}</span>
        </div>
        <div v-if="fromData.permanentActivation==0"
             class="info-item">
          <div class="label">检斤到期时间 : </div>
          <span class="content"
                :title="fromData.weightExpiryTime">{{ fromData.weightExpiryTime }}</span>
        </div>
        <div v-if="fromData.permanentActivation==0"
             class="info-item">
          <div class="label">报表到期时间 : </div>
          <span class="content"
                :title="fromData.reportExpiryTime">{{ fromData.reportExpiryTime }}</span>
        </div>
        <div v-if="fromData.permanentActivation==0"
             class="info-item">
          <div class="label">维保到期时间 : </div>
          <span class="content"
                :title="fromData.maintenanceTime">{{ fromData.maintenanceTime }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import color from '@/mixins/color'

import { getActivaionInfo } from '@/api/config/blade-config.js'
export default {
  name: 'topColor',
  mixins: [color()],
  data() {
    return {
      fromData: {},
    }
  },
  created() {
    getActivaionInfo().then(({ data: { data } }) => {
      this.fromData = data
    })
  },
  methods: {
    setDefaultImg(e) {
      e.target.style = 'display:none'
    },
  },
}
</script>

<style scoped lang="scss">
.activate-info {
  height: 310px;
  display: flex;
  .activate-info-left,
  .activate-info-right {
    display: inline-block;
    height: 100%;
  }
  .activate-info-left {
    margin-top: -15px;
    display: flex;
    justify-content: center; /*水平排列居中*/
    width: 23%;
    .title {
      padding-left: 13px;
      font-size: 28px;
      font-weight: 700;
      font-style: oblique;
    }
  }
  .activate-info-right {
    padding-top: 15px;
    width: 75%;
    margin-left: 20px;

    .info-item {
      margin: 18px 0;
    }
    .title {
      font-size: 26px;
      font-weight: 500;
      color: #739fea;
      margin-bottom: 30px;
    }

    .label {
      color: #8d8d8d;
      display: inline-block;
      width: 100px;
      vertical-align: top;
    }
    .content {
      width: calc(100% - 100px);
      color: #222222;
      vertical-align: top;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.el-dialog__header {
  padding: 20px 20px 15px;
}
</style>
